import { render, staticRenderFns } from "./BuildingAppRelationSelect.vue?vue&type=template&id=2b585353&lang=pug&"
import script from "./BuildingAppRelationSelect.vue?vue&type=script&lang=ts&"
export * from "./BuildingAppRelationSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports